import { render } from "./BlackBoxSSRTool.vue?vue&type=template&id=59961f5a&scoped=true"
import script from "./BlackBoxSSRTool.vue?vue&type=script&lang=js"
export * from "./BlackBoxSSRTool.vue?vue&type=script&lang=js"

import "./BlackBoxSSRTool.vue?vue&type=style&index=0&id=59961f5a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59961f5a"]])

export default __exports__